export default __webpack_public_path__ + "static/media/Group9236.8797fed1.svg";